import React, { useEffect, useState } from "react";
import {
  DatePicker,
  Button,
  Skeleton,
  Table,
  Result,
  Checkbox,
} from "antd";


import {
  generatedISOFormatDateString,
  getLastDayTimeRangeIST,
  getLastDayTimeRangeUTC,
} from "../../../../../../Utils/DateConverstion";
import CustomDrawer from "../../../../../Elements/CustomDrawer";
import CustomSelect from "../../../../../Elements/CustomSelect";
import { useStoreUpdaterWithAPI } from "../../../../../../Hooks/UseStoreUpdaterWithApi";
import { APIConstants } from "../../../../../../Common/APIConstants";
import { useSelector } from "react-redux";
import TableComponent from "../../../../../Elements/Grid/TableComponent";
import TableComponentReport from "../../../../../Elements/Grid/TableComponentReport";
import dayjs from "dayjs";
import * as XLSX from "xlsx";
 
const ConsumptionReportElectrical = () => {
  const { loading, makeRequest } = useStoreUpdaterWithAPI();
  const [sectionId, setSectionId] = useState(0);
  const [converterId, setConverterId] = useState();
  const [report, setReport] = useState([]);
  const [selectedMeterIds, setSelectedMeterIds] = useState([]);
  const [fromDateObj, setFromDateObj] = useState(null);
  const [fromDateString, setFromDateString] = useState(null);
  const [toDateObj, setToDateObj] = useState(null);
  const [toDateString, setToDateString] = useState(null);
  const [skip, setSkip] = useState(true);
  const [open, setOpen] = useState(false);
  const [chartSkip, setChartSkip] = useState();
  const [chartConverterInput, setChartConverterInput] = useState();
  const [chartGroupInput, setChartGroupInput] = useState();
  const [submit, setSubmit] = useState(false);
  // const [loading, setLoading] = useState(false);
  const [converterGroupId, setConverterGroupId] = useState();
  const [sectionError, setSectionError] = useState();
  const [converterError, setConverterError] = useState();
  const [fromDateError, setFromDateError] = useState();
  const [toDateError, setToDateError] = useState();
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 100,
    },
  });

  const [flowSectionResData, setflowSectionResData] = useState([]);
  const [getFlowConverterResData, setgetFlowConverterResData] = useState([]);
  const [flowGroupDetailsResData, setflowGroupDetailsResData] = useState([]);
  const [nsGetFlowConverterResData, setnsGetFlowConverterResData] = useState([]);
  const [getFlowSteamGroupMeterResData, setgetFlowSteamGroupMeterResData] = useState([]);
  const [consumptionData, setConsumptionData] = useState([])
  const [loadings, setLoadings] = useState(true);

  const [checkedValue, setCheckedValue] = useState(null);
  const [isLast24Hours, setIsLast24Hours] = useState(false);
  const [time, setTime] = useState(false);
  const [to, setTo] = useState(null);
  const [from, setFrom] = useState(null);
  const [excelToDate,setExcelToDate] = useState(null)
  const [excelFromDate,setExcelFromDate] = useState(null)

  const simulateLoading = (setLoadings) => {
    setLoadings(true);
    setTimeout(() => {
      setLoadings(false);
    }, 2000); // 2 seconds
  };
  useEffect(() => {
    simulateLoading(setLoadings);
  }, [])

  useEffect(() => {
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_FLOW_SECTION_MASTER_DETAILS}`
    }).then((res) => {
      console.log(res)
      setflowSectionResData(res);
    });

    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_ELECTRICAL_CONVERTER_DETAILS}`
    }).then((res) => {
      console.log(res)
      setgetFlowConverterResData(res);
    });

    makeRequest({
      type: APIConstants.POST,
      url: `${APIConstants.ELECTRICAL_GROUP_NAME}?Module=1`
    }).then((res) => {
      console.log(res)
      setflowGroupDetailsResData(res);
    });
  }, [])


  useEffect(() => {

    if (converterGroupId) {
      makeRequest({
        type: APIConstants.GET,
        url: `${APIConstants.GET_FLOW_NS_CONVERTER_DETAILS}?ConverterID=${converterGroupId}`
      }).then((res) => {
        console.log(res)
        setnsGetFlowConverterResData(res);
      });
    }


    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_FLOW_STEAM_GROUP_METER_DETAILS}?GroupID=${converterGroupId}`
    }).then((res) => {
      console.log(res)
      setgetFlowSteamGroupMeterResData(res);
    });
  }, [converterGroupId])

  const getFlowSectionList = (flowSectionResData && flowSectionResData) || [];
  const getFlowConverterList =
    (getFlowConverterResData && getFlowConverterResData) || [];
  const flowGroupDetailsList =
    (flowGroupDetailsResData && flowGroupDetailsResData) || [];

 

  const fetchData = (data) => {
    console.log(data.ConverterID)
    setExcelFromDate(data.FromDate)
    setExcelToDate(data.ToDate)
    console.log(data)
    makeRequest({
      type: APIConstants.GET,

      url: `${APIConstants.ELECTRICAL_CONSUMPTION_REPORT}?SectionID=${data.sectionId}&ConverterorGroupID=${data.ConverterID}&FromDate=${data.FromDate}&ToDate=${data.ToDate}`
    }).then((res) => {
      console.log(res)
      if (res) {
        setConsumptionData(res);
      }
    });
  }

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setSkip(false);
    }, 3000);

    return () => clearTimeout(timeoutId);
  }, []);


  let formattedFromDate;
  let formattedToDate;

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };


  const handleChangeSection = (changedValues) => {
    setSectionId(changedValues);
    setSelectedMeterIds();
    if (changedValues) {
      setSectionError("");
    }
  };

  const handleChangeConverterGroup = (changedValues) => {
    console.log(changedValues)
    setConverterId(changedValues);


    if (changedValues) {
      setConverterError("");
    }
  };

  const onChangeFromDate = (date, dateString) => {
    setFromDateString(dateString);
    setFromDateObj(date);
    if (dateString) {
      setFromDateError("");
    }
  };

  const onChangeToDate = (date, dateString) => {
    setToDateString(dateString);
    setToDateObj(date);
    if (dateString) {
      setToDateError("");
    }
  };


  const setChartInputConverterData = () => {
    const fromDateTimeStamp = fromDateString;

    const fromDate = new Date(fromDateString || new Date());
    const toDate = new Date(toDateString || new Date());

    const fromHours = fromDate.getUTCHours();
    const fromMinutes = fromDate.getUTCMinutes();
    const fromSeconds = fromDate.getUTCSeconds();

    const toHours = toDate.getUTCHours();
    const toMinutes = toDate.getUTCMinutes();
    const toSeconds = toDate.getUTCSeconds();

    // const [fromHours, fromMinutes, fromSeconds] = time?.split(":").map(Number);
    // const [toHours, toMinutes, toseconds] = toTimeSplit?.split(":").map(Number);

    // Set the UTC hours, minutes, and seconds
    fromDate.setUTCHours(fromHours);
    fromDate.setUTCMinutes(fromMinutes);
    fromDate.setUTCSeconds(fromSeconds);

    toDate.setUTCHours(toHours);
    toDate.setUTCMinutes(toMinutes);
    toDate.setUTCSeconds(toSeconds);

    formattedFromDate = generatedISOFormatDateString(fromDate);
    formattedToDate = generatedISOFormatDateString(toDate);

    const ids = selectedMeterIds?.map((id) => id).join(",");

    const range = getLastDayTimeRangeIST();
      console.log('From:', range.from); 
      console.log('To:', range.to);
    const inputData1 = { 
      sectionId: Number(sectionId) || 0,
      ConverterID: Number(converterId) || 0,
      FromDate: formattedFromDate || "2023-09-21 07:15:00.000",
      ToDate: formattedToDate || "2023-09-25 07:15:00.000",
    };
    const inputData2 = {
      sectionId: Number(sectionId) || 0,
      ConverterID: Number(converterId) || 0,
      FromDate: range.from || "2023-09-21 07:15:00.000",
      ToDate: range.to || "2023-09-25 07:15:00.000",
    };
    // const queryString = inputData; 
    console.log(inputData2)
    console.log(inputData1)
    // setChartConverterInput(queryString);
    console.log(isLast24Hours)
    if(isLast24Hours){
      fetchData(inputData2)
    }else{
      fetchData(inputData1)
    }
  };



  useEffect(() => {
    setChartSkip(false);
    // if (sectionId == 1) {
    setChartInputConverterData();
    // }

    // if (sectionId == 2) {
    //   setChartInputGroupData();
    // }
  }, [submit]);

  const validateInput = (value, label) => {
    const error = !value ? `Please select ${label}` : "";
    return error;
  };

  const handleSubmit = () => {

    const selectionError = validateInput(sectionId, "Section");
    const converterError = validateInput(converterId, "Converter");
    const fromDateError = validateInput(fromDateString, "From Date");
    const toDateError = validateInput(fromDateString, "From Date");

    setSectionError(sectionError);
    setConverterError(converterError);
    setFromDateError(fromDateError);
    setToDateError(toDateError);

    if (!sectionError && !converterError && !fromDateError && !toDateError) {
      onClose();
      // setSubmit(!submit);
      // if (sectionId === 1) {
      // setChartConverterInput(); 
      setChartInputConverterData()
      // fetchData()
      setSubmit(!submit); // This might be causing continuous re-renders
      // } else if (sectionId === 2) {
      //   // setChartGroupInput(); 
      //   setChartInputGroupData()
      //   // fetchData()
      //   setSubmit(!submit); // This might be causing continuous re-renders
      // }
    }
  };
  let columns = [
    { title: "Meter ID", dataIndex: "meterid", fixed: "left", width: "500px" },
    { title: "Site Name", dataIndex: "sitename", fixed: "left", width: "500px" },
    {
      title: "Meter Name",
      dataIndex: "metername",
      fixed: "left",
      width: "200px",
    },
    {
      title: "PreviousDay",
      dataIndex: "openingKwhTotal",
      fixed: "left",
      width: "200px",
    },
    {
      title: "ToDay",
      dataIndex: "closingKwhTotal",
      fixed: "left",
      width: "200px",
    },
    {
      title: "Consumption",
      dataIndex: "consumption",
      fixed: "left",
      width: "200px",
    },
  ];
 
  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;

  console.log(consumptionData)

  const handleTimeRangeChange = () => {
    const now = dayjs();
    const fromTime = now.subtract(24, "hour");
    const fromTimeString = fromTime.format("YYYY-MM-DD HH:mm:ss");
    const toTimeString = now.format("YYYY-MM-DD HH:mm:ss");
    setFromDateObj(null);
    setToDateObj(null);
      console.log('first')
      const range = getLastDayTimeRangeUTC();
      console.log('From:', range.from);
      console.log('To:', range.to);
    setFromDateString(range.from);
    setToDateString(range.to);
    setFrom(range.from);
    setTo(range.to);
    // setFromDateString(fromTimeString);
    // setToDateString(toTimeString);
    // setFrom(fromTimeString);
    // setTo(toTimeString);
  };

  const handleCheckboxChange = (e) => {
    const { checked } = e.target;
    setIsLast24Hours(checked);
    setTime(!checked);

    if (checked) {
      handleTimeRangeChange();
    } else {
      setFromDateString(null);
      setToDateString(null);
      setFromDateObj(null);
      setToDateObj(null);
    }
  };

//   const exportToExcel = (data) => {
//     console.log(data);

//     // Prepare rows for the Excel sheet
//     const rows = [];

//     // Add a header row for the table
//     const headers = [
//         "Site Name",
//         "Meter Name",
//         "Meter ID",
//         "Opening KWh Total",
//         "Closing KWh Total",
//         "Consumption",
//     ];
//     rows.push(headers);

//     // Add data rows
//     data.forEach((item) => {
//         rows.push([
//             item.sitename || "",
//             item.metername || "",
//             item.meterid || "",
//             item.openingKwhTotal || 0,
//             item.closingKwhTotal || 0,
//             item.consumption || 0,
//         ]);
//     });

//     console.log("Excel rows:", rows);

//     // Create the Excel workbook and worksheet
//     const workbook = XLSX.utils.book_new();
//     const worksheet = XLSX.utils.aoa_to_sheet(rows);
//     XLSX.utils.book_append_sheet(workbook, worksheet, "SiteReport");

//     // Generate the filename with a timestamp
//     const now = new Date();
//     const timestamp = now
//         .toLocaleString("en-US", {
//             year: "numeric",
//             month: "2-digit",
//             day: "2-digit",
//             hour: "2-digit",
//             minute: "2-digit",
//             second: "2-digit",
//             hour12: false,
//         })
//         .replace(/[/,: ]/g, "-");

//     const filename = `Site_Report_${timestamp}.xlsx`;
//     console.log("Generated Filename:", filename);

//     // Write the file to the user's system
//     XLSX.writeFile(workbook, filename);
// };


const exportToExcel = (data, fromDate, toDate) => {
  console.log(data);

  // Prepare rows for the Excel sheet
  const rows = [];

  // Add a header row for the table
  const headers = [
      "Site Name",
      "Meter Name",
      "Meter ID",
      "Opening KWh Total",
      "Closing KWh Total",
      "Consumption",
  ];

  // Add "From Date" and "To Date" to the first row
  rows.push([`From: ${fromDate.replace('T',' ').replace('.000Z',' ') || "N/A"}`, `To: ${toDate.replace('T',' ').replace('.000Z',' ') || "N/A"}`, "", "", "", ""]);

  // Add the headers row
  rows.push(headers);

  // Add data rows
  let totalConsumption = 0;
  data.forEach((item) => {
      const consumption = item.consumption || 0;
      totalConsumption += consumption;

      rows.push([
          item.sitename || "",
          item.metername || "",
          item.meterid || "",
          item.openingKwhTotal || 0,
          item.closingKwhTotal || 0,
          consumption,
      ]);
  });

  // Add a row for Total Consumption
  rows.push(["", "", "", "", "Total Consumption:", totalConsumption]);

  console.log("Excel rows:", rows);

  // Create the Excel workbook and worksheet
  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.aoa_to_sheet(rows);
  XLSX.utils.book_append_sheet(workbook, worksheet, "SiteReport");

  // Generate the filename with a timestamp
  const now = new Date();
  const timestamp = now
      .toLocaleString("en-US", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: false,
      })
      .replace(/[/,: ]/g, "-");

  const filename = `Consumption_Report_${timestamp}.xlsx`;
  console.log("Generated Filename:", filename);

  // Write the file to the user's system
  XLSX.writeFile(workbook, filename);
};

  console.log(consumptionData)

  return (
    <div className=" rounded-md w-auto"> 
    <h4 className={`text-center text-[20px] mb-5 dark ${isdarkMode ? 'darkfont' : 'whitemode'}`}>CONSUMPTION REPORT</h4>
      {
        !loadings && !loading ?
          <div className={`m-2`}>
                <div className="flex justify-end items-center m-5 mr-0">
                {/* <p 
                className={`font-[600] text-[18px] dark ${isdarkMode ? 'darkfont' : 'whitemode'}`}>
                  Consumption Report </p> */}
                  
                <Button type="primary" 
                onClick={()=>exportToExcel(consumptionData,excelFromDate,excelToDate)}
                className="blue-btn ml-10">
                        Create Excel
                </Button>
            </div>
            <TableComponentReport
              report={consumptionData}
              meters={columns}
            />
          </div>
           :
          <>
            <Skeleton active paragraph={{ rows: 6 }} />
          </>
      }

      <CustomDrawer
        title="Close"
        showDrawer={showDrawer}
        open={open}
        onClose={onClose}
      >
        <div className="flex flex-col space-y-2">
          <CustomSelect
            label="Section:"
            options={getFlowSectionList}
            onSelect={handleChangeSection}
            valueKey="sectionID"
            nameKey="sectionName"
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {sectionError}
          </small>
          <CustomSelect
            label="Converter / Group:"
            options={
              sectionId === 1 ? getFlowConverterList : flowGroupDetailsList
            }
            onSelect={handleChangeConverterGroup}
            valueKey={sectionId === 1 ? "siteID" : "groupID"}
            nameKey={sectionId === 1 ? "siteName" : "department"}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {/* {converterError} */}
          </small>
          <div className="mt-2 flex ml-[130px] gap-2 items-center  font-bold pb-3 ">

            <Checkbox checked={isLast24Hours}
              onChange={handleCheckboxChange}
              className="ml-1 mt-1 cursor-pointer"> 
              <label className={`${isdarkMode ? 'text-white' : 'text-black'}   w-32 text-left font-[600] pt-1 `}>Last 24 hours</label>
            </Checkbox>
          </div>


          {!isLast24Hours && (
            <>
              <div className="mt-2 flex">
                <label className="pr-3 w-32 text-left">From Date:</label>
                <DatePicker
                  value={fromDateObj}
                  onChange={onChangeFromDate}
                  className={` ${isdarkMode ? 'datebackground' : 'whitemode'} w-80 `}
                  dropdownClassName={isdarkMode ? 'datedropdown' : 'whitemode'}
                  showTime={{ format: "HH:mm:ss" }}
                  format="YYYY-MM-DD HH:mm:ss"
                />
              </div>
              <small className="text-red-500 font-bold ml-[150px]">
                {fromDateError}
              </small>

              <div className="mt-2 flex">
                <label className="pr-3 w-32 text-left">To Date:</label>
                <DatePicker
                  value={toDateObj}
                  onChange={onChangeToDate}
                  className={` ${isdarkMode ? 'datebackground' : 'whitemode'} w-80 `}
                  dropdownClassName={isdarkMode ? 'datedropdown' : 'whitemode'}
                  showTime={{ format: "HH:mm:ss" }}
                  format="YYYY-MM-DD HH:mm:ss"
                />
              </div>
              <small className="text-red-500 font-bold ml-[150px]">
                {toDateError}
              </small>
            </>
          )}

        </div>

        <div className="flex justify-center mt-4">
          <Button
            className="blue-btn"
            onClick={() => {
              handleSubmit();
            }}
          >
            Search
          </Button>
        </div>
      </CustomDrawer>
    </div>
  );
};

export default ConsumptionReportElectrical;


